import list from '../apiService/list';
import form from '../apiService/form';
import { baseSliceWithTags } from '../baseSlice';
import { authHeader } from '../../constants/authenticationHeader';

const tmrAccounts = {};
tmrAccounts.list = () => list('/rest/tmr-accounts', 'tmrAccount');
tmrAccounts.form = () => form('/api/tmr-accounts', 'tmrAccount');

// Upgrade mutation
const upgradeApi = baseSliceWithTags.injectEndpoints({
    endpoints: (builder) => ({
        tmrAccountupgrade: builder.mutation({
            query: (payload) => ({
                url: '/rest/tmr-accounts/upgrade',
                method: 'post',
                data: payload?.body,
                csrf: authHeader(),
            }),
        }),
        tmrAccountuserInfo: builder.query({
            query: (accountId) => ({
                url: `/rest/tmr-accounts/user-info/${accountId}`,
                method: 'get',
                csrf: authHeader(),
            }),
        }),
    }),
    overrideExisting: true,
});

// Attach hooks to tmrAccounts.form()
const originalForm = tmrAccounts.form;
tmrAccounts.form = () => {
    const result = originalForm();
    result.useTmrAccountupgradeMutation = upgradeApi.useTmrAccountupgradeMutation;
    result.useTmrAccountuserInfoQuery = upgradeApi.useTmrAccountuserInfoQuery;
    return result;
};

export default tmrAccounts;
